import { render } from "./Edit.vue?vue&type=template&id=2a9ebffa"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DisabilitiesTypes/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a9ebffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a9ebffa', __exports__)) {
    console.log('reload')
    api.reload('2a9ebffa', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=2a9ebffa", () => {
    console.log('re-render')
    api.rerender('2a9ebffa', render)
  })

}


export default __exports__